export const SUPPORTED_LANGUAGES = ['pt', 'es', 'en']